import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { textVariants } from "../../variants/index.js";
const P_P = /*#__PURE__*/ forwardRef(function({ children, className, ...props }, ref) {
    const classes = cn(textVariants(props), className);
    const domProps = cleanProps(props, Object.keys(textVariants.variants));
    return /*#__PURE__*/ jsx("p", {
        ref: ref,
        className: classes,
        ...domProps,
        children: children
    });
});
export { P_P as P };
